import client from "../client";
import { apiList } from "../apiList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    goalScores: (payload) => client.post(apiList.goldScore, { json: payload }),
};